import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

export const deleteSuperAdminUserRequest = createAction('deleteSuperAdminUserRequest');
export const deleteSuperAdminUserSuccess = createAction('deleteSuperAdminUserSuccess');
export const deleteSuperAdminUserFailure = createAction('deleteSuperAdminUserFailure');

export const deleteSuperAdminUser = (id: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(deleteSuperAdminUserRequest());

    try {
        await api.delete(`admin/superadmins/${id}`);

        dispatch(deleteSuperAdminUserSuccess());
    } catch (e) {
        handleApiErrors(dispatch, deleteSuperAdminUserFailure, e);
    }
};
